import React from 'react';
import './FeaturedContentSection.css';

type FeaturedContentItem = {
  title: string;
  description: string;
  imageSrc: string;
  imageAlt: string;
};

const featuredContentItems: FeaturedContentItem[] = [
  {
    title: 'Ders Planları',
    description:
      'Farklı sınıf seviyeleri ve dersler için hazırlanmış kullanışlı ders planlarını keşfedin.',
    imageSrc: '/images/featured-content/lesson-plans.jpg',
    imageAlt: 'Masa üzerinde ders planlama notları ve okul materyalleri',
  },
  {
    title: 'Etkinlik Örnekleri',
    description:
      'Öğrencilerin derse aktif katılımını destekleyen eğlenceli etkinliklere göz atın.',
    imageSrc: '/images/featured-content/classroom-activities.jpg',
    imageAlt: 'Sınıfta birlikte etkinlik yapan öğrenciler',
  },
  {
    title: 'Öğretmen Evrakları',
    description:
      'Günlük öğretmenlik çalışmalarında ihtiyaç duyabileceğiniz hazır evraklara kolayca ulaşın.',
    imageSrc: '/images/featured-content/teacher-documents.jpg',
    imageAlt: 'Kalemler ve öğretmen dokümanlarının yer aldığı çalışma masası',
  },
];

function FeaturedContentSection() {
  return (
    <section className="new-site-featured-content-root" aria-label="Öne çıkan içerikler">
      <h2 className="new-site-featured-content-heading">Öne Çıkan İçerikler</h2>

      <div className="new-site-featured-content-grid">
        {featuredContentItems.map((item) => (
          <article key={item.title} className="new-site-featured-content-card">
            <div className="new-site-featured-content-image-wrap">
              <img
                src={item.imageSrc}
                alt={item.imageAlt}
                className="new-site-featured-content-image"
                loading="lazy"
              />
            </div>

            <h3 className="new-site-featured-content-title">{item.title}</h3>
            <p className="new-site-featured-content-description">{item.description}</p>
          </article>
        ))}
      </div>
    </section>
  );
}

export default FeaturedContentSection;